export const UserHttpPaths = {
  userDetails: `/user-details`,
  users: `/users`,
  setActive: `/set-active`,
  resendEmailVerification: '/send-verification-email',
};
